
import React, { useState, useEffect } from 'react';
import './About.css';
import about from '../images/about.jpeg'
const About = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = [
    {
      stars: ['fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star-half-alt'],
      text: "Staffing Support India ke sath kaam karke kaafi achha experience raha. Inki team highly professional hai aur support 24x7 milta hai.",
      author: "- Ankit Jain, HR Manager"
    },
    {
      stars: ['fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star'],
      text: "Bohot hi reliable aur cost-effective service mili. Offshore staffing ke liye highly recommended!",
      author: "- Meenal Shah, Founder - TechWave Solutions"
    },
    {
      stars: ['fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star-half-alt', 'far fa-star'],
      text: "Thoda initial onboarding slow tha, lekin uske baad operations smoothly chal rahe hain. Communication acha hai.",
      author: "- Rakesh Verma, Director - Zenith Traders"
    },
    {
      stars: ['fas fa-star', 'fas fa-star', 'fas fa-star', 'fas fa-star', 'far fa-star'],
      text: "Great experience with the team. They understand our needs and deliver accordingly. Worth every penny!",
      author: "- Priya Kapoor, CEO - DesignHut"
    },
    {
      stars: ['fas fa-star', 'fas fa-star', 'fas fa-star', 'far fa-star', 'far fa-star'],
      text: "Affordable pricing, but I suggest improving the initial documentation process.",
      author: "- Raj Malhotra, Head of Operations"
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev < slides.length - 1 ? prev + 1 : 0));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : slides.length - 1));
  };

  useEffect(() => {
    const handleSmoothScroll = (e) => {
      e.preventDefault();
      const targetId = e.target.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', handleSmoothScroll);
    });

    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleSmoothScroll);
      });
    };
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-container">
          <h1 style={{ textTransform: 'capitalize', width: '' }}> save 70% of your employee cost
</h1>
          <p>
            Staffing Support India (SSI) helps companies worldwide build, manage, and scale offshore teams in India. From hiring to operations, we ensure smooth team integration so that businesses can focus on growth while we handle the rest.
          </p>
          <div className="about-hero-btns">
            <a href="/services" className="about-btn about-btn-primary">Explore Our Services</a>
            <a href="https://wa.me/918076090700" target="_blank" rel="noopener noreferrer" className="about-btn about-btn-secondary">Contact Us Today</a>
          </div>
        </div>
      </section>

      {/* Mission and Vision Section */}
   

      {/* Process Section */}


      {/* About Section */}
      <section className="about-us">
        <div className="about-us-content">
          <div className="about-us-image">
            <img src={about}  alt="About SSI Image" />
          </div>
          <div className="about-us-text">
            <h2 className="about-us-text-heading">ABOUT SSI</h2>
            <h3>Go Beyond Outsourcing. Build Teams That Drive Growth.</h3>
            <p>
   At Staffing Support India (SSI), we believe outsourcing should be more than just filling roles - it should transform how businesses scale.
<br/>
<br/>
We help global companies build dedicated, high-performing teams in India that work like an extension of their own. From accountants and bookkeepers to customer support and sales teams, we don’t just hire - we build, manage, and ensure your offshore team delivers real results.
<br/>
<br/>

With SSI, you don’t just get talent. You get a partner who understands your business, aligns with your goals, and takes the operational load off your shoulders - so you can focus on growth.
<br/>
<br/>

Whether you’re looking to streamline operations, cut costs, or expand globally, we make it simple, seamless, and sustainable.          </p>
            {/* <div className="about-us-buttons">
              <a href="https://wa.me/919301804341" target="_blank" rel="noopener noreferrer" className="about-us-btn about-btn-primary">Learn More</a>
              <a href="https://wa.me/919301804341" target="_blank" rel="noopener noreferrer" className="about-us-btn about-btn-secondary">Contact Us</a>
            </div> */}
          </div>
        </div>
      </section>
      <section id="process" className="about-section">
        <div className="about-container">
          <div className="about-section-title">
            <h2>Our Working Process</h2>
            <p>We follow a streamlined approach to build and manage your offshore team effectively</p>
          </div>
          <div className="about-process-steps">
            <div className="about-step">
              <div className="about-step-icon" data-step="1">
                <i className="fas fa-search"></i>
              </div>
              <h3>HIRE</h3>
              <p>We analyze your exact hiring & skillset requirements to find the perfect talent match for your business needs.</p>
            </div>
            <div className="about-step">
              <div className="about-step-icon" data-step="2">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>BUILD</h3>
              <p>We source, recruit, and onboard top talent aligned with your goals, ensuring a perfect cultural fit.</p>
            </div>
            <div className="about-step">
              <div className="about-step-icon" data-step="3">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>OPERATE</h3>
              <p>We handle the setup, management, and day-to-day operations so you can focus on your core business.</p>
            </div>
          </div>
        </div>
         <div className='contact-sec'>
           <a href="/contact" target="_blank" rel="noopener noreferrer" className="about-btn about-btn-primary">Know More</a>
         </div>
        
      </section>
      {/* Teams Section */}
      <section id="managed-teams" className="about-section about-teams">
        <div className="about-container">
          <div className="about-section-title">
            <h2>Teams We Manage</h2>
            <p>We specialize in building and managing high-performing teams across industries.</p>
          </div>
          <div className="about-teams-grid">
            <div className="about-team-row">
              <div className="about-team-box">
                <div className="about-team-box-head"><h3>Finance & Accounting</h3></div>
                <div className="about-team-box-body">
                  <ul>
                    <li><i className="fas fa-check-circle"></i> Bookkeeping</li>
                    <li><i className="fas fa-check-circle"></i> Payroll processing</li>
                    <li><i className="fas fa-check-circle"></i> Financial reporting</li>
                    <li><i className="fas fa-check-circle"></i> Accounts payable/receivable</li>
                  </ul>
                </div>
              </div>
              <div className="about-team-box">
                <div className="about-team-box-head"><h3>Design</h3></div>
                <div className="about-team-box-body">
                  <ul>
                    <li><i className="fas fa-check-circle"></i> CAD designers</li>
                    <li><i className="fas fa-check-circle"></i> Graphic designers</li>
                    <li><i className="fas fa-check-circle"></i> Techpack designers</li>
                    <li><i className="fas fa-check-circle"></i> UI/UX designers</li>
                  </ul>
                </div>
              </div>
              <div className="about-team-box">
                <div className="about-team-box-head"><h3>Marketing & Branding</h3></div>
                <div className="about-team-box-body">
                  <ul>
                    <li><i className="fas fa-check-circle"></i> SEO specialists</li>
                    <li><i className="fas fa-check-circle"></i> Social media branding</li>
                    <li><i className="fas fa-check-circle"></i> Digital marketing</li>
                    <li><i className="fas fa-check-circle"></i> E-commerce advertisement</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="about-team-row about-center">
              <div className="about-team-box">
                <div className="about-team-box-head"><h3>Sales & Support</h3></div>
                <div className="about-team-box-body">
                  <ul>
                    <li><i className="fas fa-check-circle"></i> Lead generation</li>
                    <li><i className="fas fa-check-circle"></i> Customer support</li>
                    <li><i className="fas fa-check-circle"></i> Inbound calling</li>
                    <li><i className="fas fa-check-circle"></i> Outbound calling</li>
                  </ul>
                </div>
              </div>
              <div className="about-team-box">
                <div className="about-team-box-head"><h3>Back-office</h3></div>
                <div className="about-team-box-body">
                  <ul>
                    <li><i className="fas fa-check-circle"></i> Data entry specialists</li>
                    <li><i className="fas fa-check-circle"></i> MIS executives</li>
                    <li><i className="fas fa-check-circle"></i> Data processing</li>
                    <li><i className="fas fa-check-circle"></i> Administrative support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section id="comparison" className="about-section about-comparison">
        <div className="about-container">
          <div className="about-section-title">
            <h2>Why Choose SSI?</h2>
            <p>Discover how our approach delivers superior results compared to traditional staffing solutions</p>
          </div>
          <div className="about-comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Traditional Staffing</th>
                  <th>SSI</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="about-feature">Recruitment</td>
                  <td className="about-traditional">Limited</td>
                  <td className="about-ssi">YES</td>
                </tr>
                <tr>
                  <td className="about-feature">End to End Team Management</td>
                  <td className="about-traditional">NO</td>
                  <td className="about-ssi">YES</td>
                </tr>
                <tr>
                  <td className="about-feature">Dedicated Support</td>
                  <td className="about-traditional">NO</td>
                  <td className="about-ssi">YES</td>
                </tr>
                <tr>
                  <td className="about-feature">Scalability</td>
                  <td className="about-traditional">Slow</td>
                  <td className="about-ssi">Fast</td>
                </tr>
                <tr>
                  <td className="about-feature">Cost Savings</td>
                  <td className="about-traditional">Limited</td>
                  <td className="about-ssi">Up to 50%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Industry Section */}
      {/* <section id="industry-section" className="about-section about-industry">
        <div className="about-container">
          <div className="about-section-title">
            <h2>Industries We Serve</h2>
            <p>We’ve successfully built teams across industries – and we’re expanding every day.</p>
          </div>
          <div className="about-industry-wrapper">
            <div className="about-industry-card about-color1">
              <i className="fas fa-shopping-cart"></i>
              <h3>E-commerce</h3>
            </div>
            <div className="about-industry-card about-color2">
              <i className="fas fa-bullhorn"></i>
              <h3>Marketing Agency</h3>
            </div>
            <div className="about-industry-card about-color3">
              <i className="fas fa-laptop-code"></i>
              <h3>IT & Fintech</h3>
            </div>
            <div className="about-industry-card about-color4">
              <i className="fas fa-industry"></i>
              <h3>Manufacturing</h3>
            </div>
            <div className="about-industry-card about-color5">
              <i className="fas fa-tshirt"></i>
              <h3>Fashion & Apparel</h3>
            </div>
            <div className="about-industry-card about-color6">
              <i className="fas fa-truck"></i>
              <h3>Logistics</h3>
            </div>
          </div>
        </div>
      </section> */}
         <section className="about-section about-mission-vision">
        <div className="about-container">
          <div className="about-mission-vision-wrapper">
            <div className="about-mission-card">
              <div className="about-mission-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h2>Our Mission</h2>
              <p>
              To provide optimal, exceptional staffing services and revolutionise small and medium sized business globally.
              </p>
            </div>
            <div className="about-vision-card">
              <div className="about-vision-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h2>Our Vision</h2>
              <p>
            To empower businesses globally to achieve operational excellence by delivering exceptional and adaptable staffing solutions and revolutionise the global workforce.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why India Section */}
      <section className="about-why-india">
        <h2>Why India?</h2>
        <div className="about-orange-line"></div>
        <p className="about-subtitle">Discover the strategic advantages of choosing India as your offshore destination</p>
        <div className="about-why-india-grid">
          <div className="about-why-card">
            <div className="about-icon"><i className="fas fa-money-bill-wave"></i></div>
            <h4>Cost Efficiency</h4>
            <p>Access highly skilled professionals at significantly lower costs.</p>
          </div>
          <div className="about-why-card">
            <div className="about-icon"><i className="fas fa-user-graduate"></i></div>
            <h4>High-Quality Talent</h4>
            <p>Leverage a tech-savvy, educated, and experienced workforce.</p>
          </div>
          <div className="about-why-card">
            <div className="about-icon"><i className="fas fa-clock"></i></div>
            <h4>24/7 Operations</h4>
            <p>Utilize time-zone advantage for round-the-clock productivity.</p>
          </div>
          <div className="about-why-card">
            <div className="about-icon"><i className="fas fa-expand-arrows-alt"></i></div>
            <h4>Scalability</h4>
            <p>Easily scale your team up or down with zero infrastructure risks.</p>
          </div>
        </div>
      </section>

      {/* Review Section */}
      {/* <section className="about-review">
        <h2>What Our Clients Say</h2>
        <div className="about-slider-container">
          <div className="about-slider" style={{ transform: `translateX(${-currentIndex * 100}%)` }}>
            {slides.map((slide, index) => (
              <div className="about-slide" key={index}>
                <div className="about-stars">
                  {slide.stars.map((star, i) => (
                    <i className={star} key={i}></i>
                  ))}
                </div>
                <p>{slide.text}</p>
                <h4>{slide.author}</h4>
              </div>
            ))}
          </div>
          <div className="about-slider-buttons">
            <button onClick={prevSlide}>❮ Prev</button>
            <button onClick={nextSlide}>Next ❯</button>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="about-cta">
        <div className="about-container">
          <h2>Ready to Build Your Offshore Team?</h2>
          <p>Start leveraging India's talent advantage today and focus on growing your business while we handle the rest.</p>
          <a href="https://wa.me/918076090700" target="_blank" rel="noopener noreferrer" className="about-btn about-btn-primary">Get Started Now</a>
        </div>
      </section>
    </div>
  );
};

export default About;
